import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import { connect } from "react-redux";
import compose from 'recompose/compose';
import { showSnackbar } from "../../actions/snackbarActions";
import { closeSnackbar } from "../../actions/snackbarActions";


// Modal for creating/editing an entity is needed
// throughout the application. To avoid using boilerplate
// code, composition is used here. 
// https://reactjs.org/docs/composition-vs-inheritance.html

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const styles = theme => ({
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
  },
  modalTitle: {
    backgroundColor: "#a2b5cc",
    color: "#13437d",
    marginTop: theme.spacing.unit * -4,
    marginLeft: theme.spacing.unit * -4,
    marginRight: theme.spacing.unit * -4,
    paddingLeft: theme.spacing.unit * 4,
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2
  }
});

class BaseModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      entityAdded: false,
      entityAddFailed: false
    }
  }

  componentDidUpdate(prevProps) {
    if(this.props.modal != null && prevProps != null && prevProps.modal.isOpen === true && this.props.modal.isOpen === false) {
      this.setState({ entityAddFailed: false,  setSubmitting: false});
    }
  }

  // Function that handles the the submit event
  // of new spesific form.
  handleSubmit = async (values, actions) => {
    try {
      await this.props.onSubmit(values);
    } catch (err) {
      this.setState({ entityAddFailed: true });
      actions.setSubmitting(false);
      this.props.showSnackbar("Request failed.");
      return;
    }
    this.setState({ entityAdded: true });

    // automatically close the modal after short period
    this.modalCloseTimeout = setTimeout(() => {
      actions.setSubmitting(false);
      this.props.handleClose();
    }, 500);
  }

  handleCloseEvent = () => {
    console.log("BaseModal handle close event");
  }

  handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    // in case of error, closing the snackbar
    // mustn't close the modal
    if (this.state.entityAddFailed) {
      this.setState({ entityAddFailed: false });
      return;
    }
    // when adding succeeds, the modal 
    // can be closed when snackbar is closed
    this.setState({ entityAdded: false });
    this.props.handleClose();
  };

  render() {
    const { classes, isOpen, handleClose, modalType, isEdit } = this.props;
    const modalTitle = isEdit ? `EDIT ${modalType.toUpperCase()}` : `ADD NEW ${modalType.toUpperCase()}`;


    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={isOpen}
        onClose={handleClose}>

        <div style={getModalStyle()} className={classes.paper}>
          <div className={classes.modalTitle}>
            <Typography variant="title" id="modal-title">{modalTitle}</Typography>
          </div>
          <Typography variant="subheading" id="simple-modal-description">
            {/* 
               We need to pass some props from this generic modal
               to our specific modal.
               https://stackoverflow.com/questions/32370994/how-to-pass-props-to-this-props-children
            */}
            {React.cloneElement(this.props.children, { handleSubmit: this.handleSubmit })}
          </Typography>


        </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
    modal: state.modal.modal
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showSnackbar: (msg) => {
       dispatch(showSnackbar(msg))
     },
     closeSnackbar: () => {
        dispatch(closeSnackbar())
     }
   }
}

export default
  compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
  )(BaseModal);


// WEBPACK FOOTER //
// ./src/components/Modals/BaseModal.js